/**
 * SectionHeader - Mobile
 * 
 * Section label with optional action.
 * Uses uppercase label style per editorial typography.
 */

import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { color, text, space } from '../../../shared/tokens/mobile';

interface SectionHeaderProps {
  label: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function SectionHeader({ label, actionLabel, onAction }: SectionHeaderProps) {
  const hasAction = actionLabel && onAction;

  if (hasAction) {
    return (
      <View style={styles.row}>
        <Text style={styles.label}>{label}</Text>
        <Pressable onPress={onAction} hitSlop={space.sm}>
          <Text style={styles.action}>{actionLabel}</Text>
        </Pressable>
      </View>
    );
  }

  return <Text style={[styles.label, styles.standalone]}>{label}</Text>;
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: space.sm,
  },
  label: {
    fontSize: text.label.fontSize,
    fontWeight: text.label.fontWeight,
    lineHeight: text.label.lineHeight,
    letterSpacing: text.label.letterSpacing,
    textTransform: text.label.textTransform,
    color: color.textMuted,
  },
  standalone: {
    marginBottom: space.sm,
  },
  action: {
    fontSize: text.caption.fontSize,
    fontWeight: text.bodyMedium.fontWeight,
    color: color.primary,
  },
});
